import { Injectable, OnDestroy } from '@angular/core';
import * as amplitude from '@amplitude/analytics-browser';
import { Identify } from '@amplitude/analytics-browser';
import { plugin as engagementPlugin } from '@amplitude/engagement-browser';
import { AmplitudeUserProperties } from '@app-core/models/core.model';

@Injectable({
  providedIn: 'root',
})
export class AmplitudeGuidesService implements OnDestroy {
  async initEngagement(): Promise<void> {
    await amplitude.add(engagementPlugin()).promise;
    console.log('✅ Engagement plugin added');

    // 🔥 IMPORTANT: boot engagement
    if ((window as any).engagement) {
      (window as any).engagement.boot();
      console.log('✅ Engagement booted');
    } else {
      console.warn('❌ Engagement script not available');
    }
  }
  identifyUser(data: AmplitudeUserProperties): void {
    if (!data?.userId) return;

    amplitude.setUserId(data.userId);
    const identify = new Identify();

    Object.entries(data).forEach(([key, value]) => {
      if (value !== undefined && key !== 'userId') {
        identify.set(key, value);
      }
    });

    amplitude.identify(identify);
  }

  openResourceCenter(): void {
    if (!window.engagement) {
      console.warn('Amplitude Guides & Surveys not initialized');
      return;
    }
    window.engagement.gs.show('resource-center');
  }

  setSessionProperty(key: string, value: any): void {
    if (!window.engagement) return;
    window.engagement.setSessionProperty(key, value);
  }

  refreshGuides(): void {
    if (!(window as any).engagement) {
      console.warn('❌ Engagement not ready');
      return;
    }

    setTimeout(() => {
      (window as any).engagement.decide();
    }, 1000);
  }

  shutdown(): void {
    window.engagement?.shutdown();
    amplitude.reset();
  }

  ngOnDestroy(): void {
    this.shutdown();
  }
}
